export const COUNTRIES_WITH_LAST_NAME_FIRST_NAME_ORDER = ['JP', 'KR']
